import React, { useContext, useEffect, useState } from 'react';
import Navigation from "../../router/Navigation";
import { GlobalContext } from '../../context/GlobalContext';
import LanguageSelector from '../common/LanguageSelector';
import { useCartContext } from '../../context/CartContext';
import { useTranslation } from 'react-i18next';
import CartDrawer from '../common/CartDrawer';

const Header = ({ currentStep }) => {
  const { store, goToStep, step } = useContext(GlobalContext);
  const { cart } = useCartContext();
  const { t } = useTranslation();
  const [drawerOpen, setDrawerOpen] = useState(false);
  const cartCount = cart.items?.length || 0;

  useEffect(() => {
    const openDrawer = () => setDrawerOpen(true);
    window.addEventListener('rf-open-cart-drawer', openDrawer);
    return () => window.removeEventListener('rf-open-cart-drawer', openDrawer);
  }, []);

  return (
    <header id="header">
      <h1 className="visually-hidden">Cartes Cadeaux</h1>
      <div className="wrapper">
        <div id="logo" className="logo">
          <a href={store.site} aria-label={`Retour au site ${store.name || 'du magasin'}`}>
            <img src={store.logo} alt={store.name || 'Magasin'} />
          </a>
        </div>
        <Navigation
          currentStep={step}
          onStepChange={goToStep}
        />
        <div className="headerRight">
        {store.languages && store.languages.length > 1 && (
          <LanguageSelector
            options={store.languages}
            displayFlag={store.display_language_flag}
            defaultLanguage={store.default_language}
          />
        )}
        {(step === 2 || step === 'payment') ? (
          <button
            type="button"
            className="headerBuyOther"
            onClick={() => goToStep(1)}
          >
            {t('Acheter une autre e-carte cadeau')}
          </button>
        ) : (
          <div id="rfCart">
            <a
              href="#"
              tabIndex="0"
              onClick={(e) => {
                e.preventDefault();
                setDrawerOpen(true);
              }}
              role="button"
              aria-haspopup="dialog"
              aria-expanded={drawerOpen}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault(); // Empêche le défilement avec la barre d'espace
                  setDrawerOpen(true);
                }
              }}
            >
              <i className="icon-panier" aria-hidden="true"></i>
              <span className="cartText">{t("Panier")}</span>
              <span className="countPanier" aria-label={`${cartCount} ${cartCount === 1 ? t("article") : t("articles")}`}>{cartCount}</span>
            </a>
          </div>
        )}
        </div>
      </div>
      <CartDrawer isOpen={drawerOpen} onClose={() => setDrawerOpen(false)} />
    </header>
  );
};

export default Header;